import React from 'react';
import { View, Flex, useTheme } from '@aws-amplify/ui-react';

const FormFooter = ({ children }) => {
  const { tokens } = useTheme();

  return (
    <View
      padding={tokens.space.medium}
      backgroundColor="rgba(12, 113, 231, 0.1)"
      borderRadius={`0 0 ${tokens.radii.large} ${tokens.radii.large}`}
      style={{
        width: '100%',
      }}
    >
      <Flex direction="column" alignItems="center" gap={tokens.space.small}>
        {children}
      </Flex>
    </View>
  );
};

export default FormFooter;
